'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncCreatable = exports.Creatable = exports.Async = undefined;

require('!!style-loader!css-loader!react-select/dist/react-select.css');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _typeahead = require('./typeahead.css');

var _typeahead2 = _interopRequireDefault(_typeahead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styled = (0, _recompose.compose)((0, _recompose.defaultProps)({
  clearable: false,
  backspaceToRemoveMessage: ''
}), (0, _recompose.withProps)(function (_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$optionClassName = _ref.optionClassName,
      optionClassName = _ref$optionClassName === undefined ? '' : _ref$optionClassName;
  return {
    className: (0, _classnames2.default)(_typeahead2.default['container'], className),
    optionClassName: (0, _classnames2.default)(_typeahead2.default['option'], optionClassName)
  };
}));

exports.default = Styled(_reactSelect2.default);
var Async = exports.Async = Styled(_reactSelect.Async);
var Creatable = exports.Creatable = Styled(_reactSelect.Creatable);
var AsyncCreatable = exports.AsyncCreatable = Styled(_reactSelect.AsyncCreatable);